import template from './employee_groups.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class AdminEmployeeGroupsViewModel
{
	constructor(page)
	{
		this.page = page;
		this.employee_groups = ko.observableArray();
	}

	async edit_group(data)
	{
		await Grape.dialog.open('EmployeeGroupsAdd', { data: data });
		this.page.updateData();
	}

	add_employee_group()
	{
		this.edit_group({});
	}

	edit_employee_group(v, e)
	{
		this.edit_group(ko.toJS(v));
	}

	// TODO: API violates FK reference
	async delete_employee_group(v, e)
	{
		let data = ko.mapping.toJS(v);
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this group entry ?')});

		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/employee_group/delete_employee_group', data);
			Utils.wrap_api_result(res, tr, async () => {
				await Grape.alerts.alert({type: 'success', title: tr('Success'), message: tr('Successfully deleted group.')});
				this.page.updateData();
			});
		}
	}

	show_employee_groups_help()
	{
		Grape.dialog.open('EmployeeGroupsHelp', { employee_id: this.page.bindings.id });
	}
}

class AdminEmployeeGroupsPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminEmployeeGroupsViewModel(this);
	}

	init()
	{
		document.title = tr('Manage Employee Groups');
		window.current_page_title(tr('Add/Edit Employee Groups'));
	}

	async updateData()
	{
		let options = {
			table: 'v_employee_group',
			schema: 'savanna',
			limit: 1000000
		}

		let res = await Grape.fetches.getJSON('/api/record', options);

		this.viewModel.employee_groups(res.records || []);
		Utils.refresh_data_visible_roles();
	}
}

export default {
	route: '[/]admin/employee_groups',
	page_class: AdminEmployeeGroupsPage,
	template: template,
	template_filename: 'translation/employee_groups'
};
